import React, { useState, useEffect } from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';
import { useDebounce } from '../../../hooks/useDebounce';
import './SearchBox.css';

/**
 * SearchBox Component
 * Debounced search input
 */
const SearchBox = ({
  value = '',
  onChange,
  placeholder = 'Search...',
  debounceMs = 500,
  showClear = true,
  autoFocus = false,
  className = ''
}) => {
  const [inputValue, setInputValue] = useState(value);
  const debouncedValue = useDebounce(inputValue, debounceMs);

  useEffect(() => {
    onChange(debouncedValue);
  }, [debouncedValue, onChange]);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleClear = () => {
    setInputValue('');
    onChange('');
  };

  return (
    <div className={`search-box ${className}`}>
      <FaSearch className="search-icon" />
      <input
        type="text"
        className="search-input"
        placeholder={placeholder}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        autoFocus={autoFocus}
      />
      {showClear && inputValue && (
        <button className="search-clear" onClick={handleClear} aria-label="Clear search">
          <FaTimes />
        </button>
      )}
    </div>
  );
};

export default SearchBox;